module.exports = __webpack_public_path__ + "static/media/smile.3db051b3.svg";